import { z } from 'zod';

const hasValidAmountPrecision = (amount: string): boolean => {
  for (const [, decimalDigits, percentageSuffix] of amount.matchAll(
    /\.([0-9]+)\s*(%|per\s*cent\b)?/gi
  )) {
    const maximumDecimalPlaces = percentageSuffix ? 3 : 2;
    if (decimalDigits.length > maximumDecimalPlaces) return false;
  }
  return true;
};

const amountTextSchema = (requiredMessage: string) =>
  z
    .string()
    .trim()
    .min(1, requiredMessage)
    .refine(
      hasValidAmountPrecision,
      'Use up to two decimal places for monetary amounts and three for percentages.'
    );

export const rebateSchema = z.object({
  supplier: z.string().trim().min(1, 'Enter a supplier'),
  service: z.string().trim().min(1, 'Enter a service'),
  estimatedAmount: amountTextSchema('Enter an estimated amount'),
});

export const feeAndChargeSchema = z.object({
  description: z.string().trim().min(1, 'Enter a description'),
  amount: amountTextSchema('Enter an amount'),
  whenPayable: z.string().trim().min(1, 'Enter when payable'),
});

export const maximumConfiguredFees = 3;
export const maximumRebates = 4;
export const feeLimitMessage =
  'The agreement PDF has four fee rows, including the title-search fee. You can add up to three fees or charges.';
export const rebateLimitMessage =
  'The agreement PDF has four rebate rows. You can add up to four rebates.';

export const feesAndChargesSchema = z
  .array(feeAndChargeSchema)
  .max(maximumConfiguredFees, feeLimitMessage);
export const rebatesSchema = z.array(rebateSchema).max(maximumRebates, rebateLimitMessage);
